<div class="flex align-items-stretch title-container">
  <h1 class="modal-title" data-cy="overview-title">Overview</h1>
</div>
<div class="flex flex-col">
  <gc-installer-vti-details [hammerRatingsDetails]="hammerRatingsDetails"></gc-installer-vti-details>

  <ng-container *ngIf="installer.type === 'INSTALLER_TEAM_LEAD' && hasCommercialWorkPercentage">
    <ion-list lines="none" class="work-experience-section" data-cy="overview-work-experience-section">
      <ion-list-header>
        <h2 data-cy="overview-work-experience-header">Work Experience</h2>
      </ion-list-header>
      <ion-item [attr.data-cy]="installer.firstName + 'overview-work-experience-details'">
        <ion-label class="ion-text-wrap" *ngIf="commercialWorkPercentage >= 50" data-cy="overview-commercial-work-description">
          {{ installer.firstName }} has {{ commercialWorkPercentage }}% commercial work experience over the last three
          years indicating a focus on commercial work with just {{ 100 - commercialWorkPercentage }}% residential work.
        </ion-label>
        <ion-label class="ion-text-wrap" *ngIf="commercialWorkPercentage < 50" data-cy="overview-residential-work-description">
          {{ installer.firstName }} has {{ 100 - commercialWorkPercentage }}% residential work experience over the last three
          years indicating a focus on residential work with just {{ commercialWorkPercentage }}% commercial work.
        </ion-label>
      </ion-item>
    </ion-list>
  </ng-container>

  <gc-installer-product-installation-subtypes
    [productInstallationSubtypes]="productInstallationSubtypes"
    [canEditProfile]="canEditProfile"
    (subtypeRemoved)="subtypeRemoved.emit($event)"
    (subtypeAdded)="subtypeAdded.emit($event)"
  ></gc-installer-product-installation-subtypes>
</div>
